import React, { memo, ReactElement, useEffect, useState } from "react";
import cx from "classnames";
import TipBox from "../TipBox";
import { getTipBoxesDataV4, showSeparator } from "@cart-ui/widgets/de-tipping-widget/helpers";
import { HorizontalScroller } from "@swiggy-private/core-ui";
import { OnTipBoxSelectionParams, TipBoxData, TipOption } from "@swiggy-private/cart-types";
import { TIP_ITEM_HEIGHT, TIP_ITEM_VISIBILITY_THRESHOLD, TIP_ITEM_WIDTH_V4 } from "@cart-ui/constants/DeTip";

import styles from "./TipsWrapper.scss";

export interface TipsWrapperProps {
    tipOptions: TipOption[];
    selectedTipAmount: number;
    onTipBoxSelection: (args: OnTipBoxSelectionParams) => void;
}

const getItems = (
    tipBoxesData: TipBoxData[],
    onTipBoxSelection: (args: OnTipBoxSelectionParams) => void,
): ReactElement[] => {
    return tipBoxesData.map(tipBoxData => (
        <TipBox onTipBoxSelection={onTipBoxSelection} key={tipBoxData.text} {...tipBoxData} />
    ));
};

const TipsWrapper = ({ tipOptions, selectedTipAmount, onTipBoxSelection }: TipsWrapperProps): ReactElement => {
    const _getTipBoxesData = getTipBoxesDataV4;

    const [tipBoxData, setTipBoxData] = useState(_getTipBoxesData(selectedTipAmount, tipOptions));

    const separator = showSeparator(tipBoxData);

    useEffect(() => {
        const tipBoxesData = _getTipBoxesData(selectedTipAmount, tipOptions);
        setTipBoxData(tipBoxesData);
    }, [_getTipBoxesData, selectedTipAmount, tipOptions]);

    return (
        <>
            <div className={styles.tipsWrapper}>
                <HorizontalScroller
                    containerClassName={cx(styles.tipsWrapperScrollBarContainer)}
                    itemClassName={styles.tipsWrapperItemContainer}
                    onItemVisible={(): null => null}
                    items={getItems(tipBoxData, onTipBoxSelection)}
                    height={TIP_ITEM_HEIGHT}
                    itemVisibilityThreshold={TIP_ITEM_VISIBILITY_THRESHOLD}
                    width={TIP_ITEM_WIDTH_V4}
                />
            </div>
            {separator && <div className={styles.tipsSeparator} />}
        </>
    );
};

export default memo(TipsWrapper);
